import { Component, OnInit } from '@angular/core';
import { SalaryService } from '../../../services/salary.service';
import { SalaryReport } from '../../../models/salaries/salaryReport';
import { SALARIES_COLUMNS } from '../../../contants/columns/columns.salaries';
import { DateHelper } from '../../../helpers/DateHelper';
import { Trip } from '../../../models/trips/trip';
import { EMPLOYEE_ROLES } from '../../../contants/EMPLOYEE_ROLES';
import { TripHistory } from '../../../models/trips/tripHistory';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { Router } from '@angular/router';

@Component({
	selector: 'app-salary-report',
	templateUrl: './salary-report.component.html',
	styleUrls: ['./salary-report.component.css']
})
export class SalaryReportComponent implements OnInit {

	columns = SALARIES_COLUMNS;
    data: SalaryReport[];
	
	dateFrom: string;
	dateTo: string;
	role: string;

	constructor(
        private _salaryService: SalaryService,
        private _router: Router
	) { }

	ngOnInit() {
		this.init();
	}

	private init(){
		this.data = [];
		
		let period = DateHelper.getMonthlyPeriod(new Date());
		this.dateFrom = period.from;
		this.dateTo = period.to;

		this.getReport();
	}

	getReport() {
		this.data = [];
		this._salaryService.getSalaryReport(this.dateFrom, this.dateTo, this.role).subscribe(
			result => {
				if(result != undefined){
                    this.data = result;
				}
			}
		);
    }
    
    getRate(employeeRole: string, trip: TripHistory) : number{
        if(employeeRole == EMPLOYEE_ROLES.driver){
            return trip.driverRate;
        }
        else if(employeeRole == EMPLOYEE_ROLES.helper){
            return trip.helperRate;
        }

        return 0;
    }

    showDetails(report: SalaryReport) {
        report.showDetails = report.showDetails == undefined || report.showDetails == false ? true : false;
    }

    goToDailyTrip(id: number){
        this._router.navigate([APP_ROUTES.dailyTripForm.replace('/:id', ''), id]);
    }

    goToCashAdvance(id: number){
        this._router.navigate([APP_ROUTES.cashAdvanceForm.replace('/:id', ''), id]);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/salaries/salary-report/salary-report.component.ts